import { render, staticRenderFns } from "./representativePatent.vue?vue&type=template&id=f83d67b0"
import script from "./representativePatent.vue?vue&type=script&lang=js"
export * from "./representativePatent.vue?vue&type=script&lang=js"
import style0 from "./representativePatent.vue?vue&type=style&index=0&id=f83d67b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports